import common from "../../utill/Common";

class ProductService {
  fetchAll = async (token) => {
    const url = common.baseUrl + "admin/products/fetch";

    const options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
      body: null,
    };

    const response = await fetch(url, options);

    return response.json();
  };
}

// eslint-disable-next-line import/no-anonymous-default-export
export default new ProductService();
